import {
  userProfileToolDef,
  type UserProfileToolDef,
} from '@form-factory/schema/contracts';

import { ToolNoDataError } from './components/ToolNoDataError';
import { UserProfile } from './membershipTool/components/UserProfile';
import { createToolComponent } from '../../toolRegistry';
import { Message } from '../ui';

export const UserProfileTool = createToolComponent(
  {
    schema: {
      content: userProfileToolDef,
    },
  },
  ({ toolCall, state, content }) => {
    // Don't render during streaming
    if (state === 'call' || state === 'call-partial') {
      return null;
    }

    // Get data - ToolProvider already unwrapped it
    const data = state === 'result' && content ? content : toolCall.args;

    // Return early if we don't have data
    if (!data) {
      return null;
    }

    const args = data as UserProfileToolDef;

    if (!args.content && (state === 'call-complete' || state === 'result')) {
      return <ToolNoDataError />;
    }

    return (
      <Message.BubbleGroup>
        <UserProfile profile={{ ...args, content: args.content }} />
      </Message.BubbleGroup>
    );
  },
);
